import { render } from "./BrandCope.vue?vue&type=template&id=2852f45a"
import script from "./BrandCope.vue?vue&type=script&lang=ts"
export * from "./BrandCope.vue?vue&type=script&lang=ts"

import "./BrandCope.vue?vue&type=style&index=0&id=2852f45a&lang=scss"
script.render = render

export default script